// components/ScheduleDateModal.jsx
import React from "react";
import { Modal, DatePicker, message } from "antd";
import dayjs from "dayjs";

// Required dayjs plugins
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import customParseFormat from "dayjs/plugin/customParseFormat";

// Extend dayjs
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(customParseFormat);

const ScheduleDateModal = ({
  visible,
  onClose,
  onConfirm,
  selectedDate,
  onDateChange,
}) => {
  const handleOk = () => {
    if (!selectedDate || !dayjs(selectedDate).isValid()) {
      message.warning("Please select a valid date and time.");
      return;
    }
    onConfirm(); // Only call DraftSave (DraftData(true)) from parent
    onClose();
  };

  return (
    <Modal
      title="Schedule Email"
      open={visible}
      onCancel={onClose}
      onOk={handleOk}
      okText="Schedule"
      cancelText="Cancel"
      destroyOnClose
    >
      <DatePicker
        showTime={{ use12Hours: true }}
        value={selectedDate ? dayjs(selectedDate) : null}
        onChange={(date) => {
          if (date && dayjs(date).isValid()) {
            onDateChange(date.toISOString());
          } else {
            onDateChange(null);
          }
        }}
        format="YYYY-MM-DD HH:mm A"
        style={{ width: "100%" }}
        placeholder="Select date and time"
      />
    </Modal>
  );
};

export default ScheduleDateModal;
